/**
 * Created by jv on 29/03/2017.
 */
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");

require("Styles/components/catalog-add-dialog.scss");

module.exports = class CartTemplate
{
  constructor(options)
  {
    /*
     * options.appendTo
     * options.cart (Cart object [models/store/cart.js])
     *
     * options.setItemQuantity(key, quantity)
     */

    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.dialogId = utils.isNullOrEmpty(options.dialogId) ? "catalog-add-dialog-" + utils.generateUIDShort() : options.dialogId;
    this.backdropIdSuffix = "-modal-backdrop";

    this.title = options.title;

    this.cartQuantity = utils.isNotNull(options.cartQuantity) ? options.cartQuantity : 0;
    this.cartPrice = utils.isNotNull(options.cartPrice) ? options.cartPrice : 0;

    this.catalog = options.catalog;
    this._article = options.article;

    this.confirmBtnText = options.confirmBtnText;
    this.cancelBtnText = options.cancelBtnText;

    this.onConfirm = options.onConfirm;
    this.onCancel = options.onCancel;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.dialogEl = $("<div id='" + this.dialogId + "' class='modal catalog-add-dialog fade'>" +
                          "<div class='modal-dialog'>" +
                            "<div class='modal-content clearfix'>" +
                            "</div>" +
                          "</div>" +
                        "</div>");
      this.dialogContentEl = this.dialogEl.find(".modal-content");

      this.backdrop = "<div id='" + this.backdropId + "' class='modal-backdrop fade'></div>";

      this.refresh();

      $("body").append(this.dialogEl);
      this.addDisposeListener();

      this._initialized = true;
    }
  }

  refresh()
  {
    this.dialogContentEl.empty();

    this.renderTitle();
    this.renderArticle();
    this.renderCartQuantity();
    this.renderButtonGroup();
  }

  renderTitle()
  {
    if(!utils.isNullOrEmpty(this.title))
    {
      this.dialogContentEl.append("<h3 class='dialog-title'>" + this.title + "</h3>");
    }
  }

  renderArticle()
  {
    if(utils.isNotNull(this.article))
    {
      var articleWrapper = $("<div class='article-wrapper clearfix'></div>");

      var title = utils.isNullOrEmpty(this.article.title) ? "" : this.article.title;
      var author = utils.isNullOrEmpty(this.article.author) ? "" : this.article.author;
      var publisher = utils.isNullOrEmpty(this.article.publisher) ? "" : this.article.publisher;

      articleWrapper.append("<div class='article-image'><img src='" + this.article.image + "'/></div>");
      articleWrapper.append("<div class='article-info-wrapper'>" +
                              "<div class='article-info'>" +
                                "<div class='article-title'>" + title + "</div>" +
                                "<div class='article-author'>" + author + "</div>" +
                                "<div class='article-publisher'>" + publisher + "</div>" +
                              "</div>" +
                              "<div class='align-bottom'>" +
                                "<div class='article-price'>" +
                                  "<div class='price'>" + this.catalog.currency + " " + this.article.priceVat + "</div>" +
                                  "<div class='vat'>" + LanguageManager.getValueForKey("store.catalog.vat.inclusive") + " " + this.article.vatPercentage + "% " + LanguageManager.getValueForKey("store.catalog.vat") + "</div>" +
                                "</div>" +
                              "</div>" +
                            "</div>");

      this.dialogContentEl.append(articleWrapper);
    }
  }

  renderCartQuantity()
  {
    var text = utils.format(LanguageManager.getValueForKey("store.catalog.add_dialog.cart_quantity"), this.cartQuantity, this.cartPrice)
    this.dialogContentEl.append("<div class='cart-quantity'>" + text + "</div>");
  }

  renderButtonGroup()
  {
    var that = this;
    var buttonGroupEl = $("<div class='button-group'></div>");

    var confirmBtn = $("<button class='btn btn-main no-icon confirm-btn' type='button'>" + that.confirmBtnText + "</button>");
    var cancelBtn = $("<button class='btn btn-main no-icon cancel-btn' type='button'>" + that.cancelBtnText + "</button>");

    confirmBtn.on("click", function(e)
    {
      if(utils.isFunction(that.onConfirm))
      {
        that.onConfirm();
      }
    });

    cancelBtn.on("click", function(e)
    {
      if(utils.isFunction(that.onCancel))
      {
        that.hide();
        that.onCancel();
      }
    });

    buttonGroupEl.append(confirmBtn);
    buttonGroupEl.append(cancelBtn);

    this.dialogContentEl.append(buttonGroupEl);
  }

  destroy()
  {
    this.hide();

    if(utils.isNotNull(this.dialogEl) && this.dialogEl.length)
    {
      this.dialogEl.remove();
    }

    this._initialized = false;
  }

  show()
  {
    var $body = $("body");
    if(!$body.hasClass("modal-open"))
    {
      $body.addClass("modal-open");
    }

    if(!this.backdropExists)
    {
      $body.append(this.backdrop);
      $("#" + this.backdropId).addClass("in");
    }

    // Reading a css property forces layout to be (re)computed
    this.dialogEl.css("display", "block");
    this.dialogEl.css("width");
    this.dialogEl.addClass("in");
  }

  hide()
  {
    var that = this;
    var $body = $("body");
    if($body.hasClass("modal-open"))
    {
      $body.removeClass("modal-open");
    }

    $("#" + that.backdropId).remove();

    that.dialogEl.removeClass("in");

    setTimeout(function()
    {
      that.dialogEl.hide();
    }, 150);
  }

  cancel()
  {
    this.hide();

    if(utils.isFunction(this.onCancel))
    {
      this.onCancel();
    }
  }

  addDisposeListener()
  {
    var that = this;

    that.dialogEl.off().on("click", function(e)
    {
      if(e.target.className === "modal-content" || $(e.target).closest(".modal-content").length)
      {
        e.stopPropagation();
        return;
      }

      that.cancel();
    });
  }

  get backdropId()
  {
    return this.dialogId + this.backdropIdSuffix;
  }

  get backdropExists()
  {
    return $("#" + this.backdropId).length;
  }

  get article()
  {
    return this._article;
  }

  set article(article)
  {
    this._article = article;
    this.refresh();
  }
};



// WEBPACK FOOTER //
// ./app/js/templates/store-catalog-add-dialog.template.js